<template>
    <div id='daily'>

        <!-- Filter Form -->

        <form class='form-inline hidden-print'>
            <div class='grp'>
                <!-- Date -->
                <div class='form-group'>
                    <label>Date:</label>
                    <datepicker
                        v-model='filter.date'
                        format='M/d/yyyy'
                        :bootstrap-styling='true'
                        @closed='loadEvents'
                    ></datepicker>
                </div>
                <!-- Location -->
                <div class="form-group">
                    <label>Location:</label>
                    <vue-rvc-location
                        :api-endpoint='$rvc.locApiEndpoint'
                        v-model='filter.location'
                        @input='loadEvents()'
                    ></vue-rvc-location>
                </div>
                <div v-show='err' class='form-group text-danger'>
                    <span class='glyphicon glyphicon-exclamation-sign'></span> {{err}}
                </div>
                <div v-show='loading' class='form-group loading'>
                    <span class='glyphicon glyphicon-repeat spinning'></span> Loading...
                </div>
            </div>
            <div class='grp'>
                <!-- Event Type (Meeting/Academic) -->
                <event-type-filter
                    v-model='filter.eventtype'
                    :events='events'
                ></event-type-filter>
                <!-- Text Filter -->
                <div class='form-group'>
                    <label>Filter:</label>
                    <div class='input-group'>
                        <span class='input-group-addon'><span class='glyphicon glyphicon-search'></span></span>
                        <input type='text' v-model='filter.text' class='form-control' placeholder='Filter by text...' />
                    </div>
                </div>
            </div>
        </form>

        <!-- Report Summary (printed and on-screen) -->

        <h2 class="text-center visible-print">Schedule for {{filter.location.display}}</h2>
        <h4 class="text-center visible-print">{{dateLongFormat(filter.date)}}</h4>
        <h4 class="text-center visible-print" v-if="filterHasExclusions">
            <!-- Report event type filtering -->
            <span v-if="filter.eventtype.course===filter.eventtype.meeting && filter.eventtype.sectypecode===''">
            </span>
            <span v-else-if="filter.eventtype.course">
                Showing only <span v-if="filter.eventtype.meeting">meetings and</span> <span v-if="filter.eventtype.sectypecode">{{sectypes[filter.eventtype.sectypecode].description}}</span> courses.
            </span>
            <span v-else-if="filter.eventtype.meeting">
                Showing only meetings.
            </span>
            <!-- Report text filtering -->
            <span v-if="filter.text">
                Filter by "{{filter.text}}".
            </span>
        </h4>
        <p class='reportsummary'>
            There {{eventsFiltered.length===1?'is':'are'}} {{eventsFiltered.length}} {{eventsFiltered.length===1?'event':'events'}} matching your criteria.
        </p>

        <!-- Data Table -->

        <table v-show='eventsFiltered.length' ref='eventTable' class='table table-striped table-hover'>
        <thead>
            <tr>
                <th>Time</th>
                <th>Event</th>
                <th>Location</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for='event in eventsFiltered' v-bind:key='event.id'
                :data-title='formatPopoverTitle(event)'
                :data-content='formatPopoverContent(event)'
            >
                <td>{{timeRange(event.start,event.end)}}</td>
                <td>{{event.title}}</td>
                <td>{{event.locationShort}}</td>
            </tr>
        </tbody>
        </table>

    </div>
</template>

<script>
import {dateLongFormat, timeRange} from '../model/formatters';
import Datepicker from 'vuejs-datepicker';
import Event from '../model/Event';
import {EventFilter} from '../mixins/EventFilter';
import {EventPopover} from '../mixins/EventPopover';
import EventTypeFilter from './EventTypeFilter.vue';
import {RefreshData} from '../mixins/RefreshData';
import {VueRvcLocation} from 'vue-rvc-location';
export default {
    name: 'daily',
    mixins: [
        EventFilter,
        EventPopover,
        RefreshData
    ],
    components: {
        Datepicker,
        EventTypeFilter,
        VueRvcLocation
    },
    data() {
        return {
            err: '',
            loading: false,
            sectypes: Event.SECTIONTYPES,
            filter: {
                date: new Date(),
                location: {bldg: '', room: '', display: 'All Buildings'}
            },
            events: []
        };
    },
    methods: {
        dateLongFormat,
        timeRange,
        loadEvents() {
            clearTimeout(this.refreshTimer);
            this.err = '';
            this.loading = true;
            this.$http
                .get('api/cal.cfc', {
                    params: {
                        method: 'getEvents',
                        date: this.filter.date.toISOString(),
                        bldg: this.filter.location.bldg,
                        room: this.filter.location.room
                    }
                })
                .then(
                    response=>{
                        this.events = response.data.map(obj=>new Event(obj));
                        // Set a timer to rerun the loadEvents method at next designated refresh time
                        this.refreshTimer = this.setRefreshTimer(this.loadEvents);
                    },
                    err=>{
                        this.err = err.statusText;
                        this.events = [];
                    }
                )
                .finally(()=>{
                    this.loading = false;
                });
        }
    },
    mounted() {
        this.$nextTick(this.loadEvents);
    }
};
</script>

<style src="../css/form-global.css" scoped></style>
<style src="../css/report-global.css" scoped></style>
<style src="../css/loading-spinner.css" scoped></style>
<style scoped>
.reportsummary {
    margin: 0 0 10px;
    color: #555;
    font-style: italic;
}
.table tbody tr {
    cursor: pointer;
}
@media print {
    .reportsummary {
        text-align: center;
    }
}
</style>